import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import utils from "../utils";
import { FormattedDate } from "react-intl";

export default ({
  link,
  symbol,
  name,
  fee,
  available,
  updated,
  handleWatchlistClick,
  onClickAddAlert,
  onWatchlist,
}) => {
  const buttonText = onWatchlist ? "Remove" : "Add";
  const buttonClass = onWatchlist ? "danger" : "success";

  return (
    <tr>
      <td>
        <Link to={link}>{symbol}</Link>
      </td>
      <td>{name}</td>
      <td style={{ textAlign: "right" }}>
        {fee != null ? utils.toPercentage(fee) : "N/A"}
      </td>
      <td style={{ textAlign: "right" }}>{utils.toCommas(available)}</td>
      {updated != null ? (
        <td style={{ textAlign: "right" }}>
          <FormattedDate
            value={updated}
            year="numeric"
            month="short"
            day="2-digit"
            hour="numeric"
            minute="numeric"
          />
        </td>
      ) : null}
      <td style={{ textAlign: "center" }}>
        <Button
          onClick={() => handleWatchlistClick(symbol)}
          bsSize="xs"
          bsStyle={buttonClass}
        >
          {buttonText}
        </Button>
      </td>
      <td style={{ textAlign: "center" }}>
        <Button
          onClick={() => onClickAddAlert(symbol)}
          bsSize="xs"
          bsStyle="success"
        >
          Add Alert
        </Button>
      </td>
    </tr>
  );
};
